import { Layout } from 'antd';

const { Content } = Layout;

interface DefaultLayoutContentProps {
  children: React.ReactNode;
}
export default function DefaultLayoutContent(props: DefaultLayoutContentProps) {
  return (
    <Content
      className='site-layout-background dark:bg-gray-900'
      style={{
        padding: '0 24px 24px', // top: 0, right: 24, bottom: 24, left: 24
        margin: 0,
        minHeight: 'auto !important',
        flexShrink: 0,
      }}
    >
      {props.children}
    </Content>
  );
}
